// Как звать локацию в тесных местах интерфейса.
//
// Название филиала — это адрес целиком («Мурманск, Школа танцев, проспект
// Кольский 51»). В карточке и в шапке он уместен, а в выпадашке фильтра, в
// плашке и в узком столбце обрезается многоточием — и две мурманские локации
// становятся неразличимы. Для таких мест в справочнике есть «Сокращённое
// название» (правка владельца 19.08); не заполнено — показываем полное.
//
// Клиентские тексты (уведомления, мини-апп, документы) сокращение НЕ используют:
// человеку нужен адрес.

/** Короткое имя локации, если задано; иначе полное. */
export function branchLabel(
  branch: { name: string; shortName?: string | null } | null | undefined,
): string {
  if (!branch) return '—';
  const short = branch.shortName?.trim();
  return short && short.length > 0 ? short : branch.name;
}

/**
 * Подпись выбора филиалов в шапке (план 106, мультивыбор).
 *
 * Пусто — «Все филиалы» (та же договорённость, что у пустого списка на
 * сервере). Один — его короткое имя. Несколько — счётчик: адреса мурманских
 * локаций различаются одним словом в конце и в подпись всё равно не влезут.
 */
export function branchSelectionLabel(
  selected: Array<{ name: string; shortName?: string | null }>,
): string {
  if (selected.length === 0) return 'Все филиалы';
  if (selected.length === 1) return branchLabel(selected[0]);
  return `${selected.length} ${pluralBranches(selected.length)}`;
}

/** Русская форма слова «филиал» для счётчика: 1 филиал, 2 филиала, 5 филиалов. */
export function pluralBranches(n: number): string {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 14) return 'филиалов';
  switch (n % 10) {
    case 1:
      return 'филиал';
    case 2:
    case 3:
    case 4:
      return 'филиала';
    default:
      return 'филиалов';
  }
}
